"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const react_1 = require("react");
const __1 = require("../../..");
const SearchField = (props) => {
    const [searchWord, setSearchWord] = react_1.useState('');
    react_1.useEffect(() => {
        props.updateItems(props.allItems.filter((item) => props.doesItemMatchWord(searchWord, item)));
    }, [searchWord, props.allItems]);
    return (React.createElement(__1.Search, { searchWord: searchWord, onChange: handleSearch, clearFunction: clearSearch, placeholder: props.searchPlaceHolder, size: props.size }));
    function clearSearch() {
        setSearchWord('');
    }
    function handleSearch(e) {
        setSearchWord(e.target.value);
    }
};
exports.default = SearchField;
//# sourceMappingURL=SearchField.js.map